var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcNotificationHeaderGreen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5787 20.2372C-0.172068 20.2372 -0.172068 17.4857 1.5787 17.4857C2.996 17.4857 3.07937 12.1601 3.07937 10.2961C3.07937 5.85814 5.58047 3.28411 8.41505 2.66279C7.91483 1.42016 8.74853 0 9.99908 0C11.2496 0 12.0833 1.42016 11.5831 2.66279C14.4177 3.28411 16.9188 5.85814 16.9188 10.2961C16.9188 12.1601 17.0022 17.4857 18.4195 17.4857C20.1702 17.4857 20.1702 20.2372 18.4195 20.2372H1.5787Z",
    fill: "#7BCB45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8285 21.1597C12.6418 22.4023 11.6252 24 9.99878 24C8.37233 24 7.3558 22.4023 8.16903 21.1597H11.8285Z",
    fill: "#7BCB45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNotificationHeaderGreen);
export default __webpack_public_path__ + "static/media/icNotificationHeaderGreen.66d800831a7b0d378a13119cb9d0048c.svg";
export { ForwardRef as ReactComponent };